import _ from 'lodash';
import { BS_API_URL, DUTY_API_URL, EHAND_API_URL, EQUIPMENT_API_URL, SYS_API_URL, TV_API_URL } from '../config';

const rewriteURL = (baserUrl, list) => {
  return _.map(list, (item) => baserUrl + item);
};

const bedstatus = {
  editBsDiagnosis: '/update/bsDiagnosis',
  createBsDiagnosis: '/create/bsDiagnosis',
  createBsRemark: '/create/bsRemark',
  postCreateBsBooking: '/create/bsTransferRequest',
  postUpdateBsBooking: '/update/bsTransferRequest',
  postSaveRemark: '/save/remark',
  postUpdateDischg: '/update/dischg',
  postUpdateStatus: '/update/status',
  postUpdateTbc: '/update/tbc',
  postSaveReturnDayCase: '/save/retunDayCase',
  postCreateBsTransferOutRequest: '/create/bsTransferOutRequest',
  postUpdateBsTransferOutRequest: '/update/bsTransferOutRequest',
  postSaveTransferOut: '/save/transferOut',
  createFloorPlan: '/create/floorPlan',
  updateFloorPlan: '/update/floorPlan',
  updateCubicle: '/update/cubicle',
  updateCubicleBed: '/update/cubicleBed',
  updateCubicleRemark: '/update/bsCubicleRemark',
  createCubicleRemark: '/create/bsCubicleRemark',
  updateWardRemark: '/update/bsWardRemark',
  createWardRemark: '/create/bsWardRemark',
};

const dutyAssign = {
  saveCheckInOut: '/save/checkInOut',
  postCteateTemporaryStaff: '/create/temporaryStaff',
  postUpdateTemporaryStaff: '/update/temporaryStaff',
  postUpdateDaDuty: '/update/daDuty',
  postUpdateTemplateRoster: '/update/daDutyTemplateRoster',
  postCreateTemplateRoster: '/create/daDutyTemplateRoster',
  postCreateDaDutyTemplate: '/create/daDutyTemplate',
  saveDraft: '/daDuty/draft/save',
  updateRosterDispType: '/update/rosterDispType',
};

const eadmission = {
  saveSpecialtyDefaultList: '/create/specialty/default',
  saveAndBatchSpecialtyDefaultList: '/batch/update/specialty',
  createSpecialty: '/create/specialty',
  editWorkflow: '/edit/workflow',
  updateSpecialty: '/update/specialty',
  editAdmission: '/admission/edit',
  createRemark: '/create/remark',
  updateRemark: '/update/remark',
  createSpecialAlert: '/create/specialAlert',
  updateSpecialAlert: '/update/specialAlert',
  createAlertAlarm: '/create/alertAlarm',
};

const ehandover = {
  postUpdateItem: '/update/taskItem',
  postCreateComment: '/create/commentitem',
  postCreateTask: '/create/task',
  updateTask: '/update/task',
  updateScheduleTask: '/update/schedule/task',
  deleteTask: "/delete/task",
  deleteScheduleTask: "/delete/schedule/task",
  deleteDraft: "/delete/draft",
  updateDraftTask: "/update/draft/task",
  taskTemplateAdd: "/task/template/add",
  taskTemplateEdit: "/task/template/edit",
  taskTemplateDelete: "/task/template/delete",
  createCommentItem: "/create/commentitem",
};

const equipment = {
  newLoanRequset: '/loanRequest/new',
  updateRequest: '/loanRequest/update',
  updateEquipmentStatus: '/equipment/update',
  registerEquipment: '/equipment/register',
  createAds: '/ads/create',
};

const system = {
  createSysRole: '/create/sysRole',
  createSysUser: '/create/sysUser',
  updateSysRole: '/update/sysRole',
  updateSysUser: '/update/sysUser',
  createSysWard: '/create/sysWard',
  updateWard: '/update/sysWard',
  updateSysDataMapping: '/update/sysDataMapping',
  createSysNotification: '/create/sysNotification',
  addEquipmentCategory: '/create/eqCategory',
  editEquipmentCategory: '/update/eqCategory',
  createHospital: '/create/sysHospital',
  updateHospital: '/update/sysHospital',
  createHospitalTag: '/create/hospitalTag',
  updateHospitalTag: '/update/hospitalTag',
  createWardTag: '/create/wardTag',
  updateWardTag: '/update/wardTag',
};

const teleVisit = {
  postRobotRegister: '/robot/register',
  postUpdateRobot: '/robot/update',
  postAddServiceHours: '/serviceHour/add',
  postUpdateServiceHours: '/serviceHour/update',
  postAddUpdateQuotaSetting: '/setting/quota/update',
  updateTimeslotStatus: '/timeslot/status/update',
  updateBooking: '/timeslotBooking/update',
  saveTelevisitMapping: '/televisitMapping/save',
};

const throttleUrlMap = _.flatMap([
  rewriteURL(BS_API_URL, bedstatus),
  rewriteURL(DUTY_API_URL, dutyAssign),
  rewriteURL(EHAND_API_URL, ehandover),
  rewriteURL(EQUIPMENT_API_URL, equipment),
  rewriteURL(SYS_API_URL, system),
  rewriteURL(TV_API_URL, teleVisit),
]);

export default throttleUrlMap;
